import {auth} from '@drivesally/sally-fn';
import authKey from '../../constants/authKey.constants';
import * as storage from '../../libs/localStorage';

export default ({authorize = true} = {}) => {
  // Fall back to in-memory authToken if localStorage was cleared by another tab
  const token = storage.get(authKey) || auth.token.get();
  const h = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  if (!!token && authorize) h.Authorization = `JWT ${token}`;
  return h;
};
